import React from 'react';

const WineInfo = ({ 
  wineInfo, 
  currentWine,
  onPurchaseDecision, 
  purchaseDecisions = {}, 
  submittedDecisions = {},
  isEatingIn = false
}) => {
  // Process wine info data - handle different response structures
  const processedInfo = wineInfo?.wine_information || wineInfo;
  
  if (!processedInfo || typeof processedInfo !== 'object') {
    return (
      <div className="wine-card-wrapper">
        <div className="restaurant-summary">
          <div className="wine-info-message">
            {typeof wineInfo === 'string' ? wineInfo : 
             'Wine information available - check console for details'}
          </div>
        </div>
      </div>
    );
  }
  
  const wineId = currentWine.id;
  const userDecision = purchaseDecisions[wineId];
  const isSubmitted = submittedDecisions[wineId];
  
  return (
    <div className="wine-card-wrapper">
      <div className="restaurant-summary">
        <div className="wine-info-subsection">
          <h4>About This {isEatingIn ? 'Wine Style' : 'Wine'}</h4>
          <p>{processedInfo.wine_info}</p>
        </div>
        
        <div className="wine-info-subsection">
          <h4>Interesting Facts</h4>
          <p>{processedInfo.wine_facts}</p>
        </div>
        
        <div className="wine-info-subsection">
          <h4>{isEatingIn ? 'Questions to Consider' : 'Questions for Your Sommelier'}</h4>
          <ul className="suggested-questions">
            {processedInfo.suggested_questions?.map((question, index) => (
              <li key={index}>{question}</li>
            ))}
          </ul>
        </div>
        
        <div className="wine-purchase-decision">
          <h4>Would you buy this wine?</h4>
          <div className="purchase-buttons">
            <button 
              className={`purchase-btn yes ${userDecision === 'yes' ? 'selected' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                onPurchaseDecision(wineId, 'yes');
              }}
              disabled={isSubmitted}
            >
              👍 Yes
            </button>
            <button 
              className={`purchase-btn no ${userDecision === 'no' ? 'selected' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                onPurchaseDecision(wineId, 'no');
              }}
              disabled={isSubmitted}
            >
              👎 No
            </button>
          </div>
          {isSubmitted && (
            <p className="submitted-message">✓ Response recorded</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default WineInfo;
